// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__mkMIi"};